import React from 'react';

export function AuthDiscord({props, match}) {
	let url = match.params.url || 'dashboard';
    window.location.href = `https://fusionbotapi.discloud.app/api/auth/discord/${url}`;
}